import React from "react";
import { Button } from "antd";
import { LeftOutlined } from "@ant-design/icons/lib/icons";
import { FormActions as StyledFormActions } from "../styles";

interface FormActionsProps {
  isAtBottom: boolean;
  onCancel: () => void;
  onSaveAndHide: () => void;
  onSaveAndShow: () => void;
}

const FormActions: React.FC<FormActionsProps> = ({
  isAtBottom,
  onCancel,
  onSaveAndHide,
  onSaveAndShow,
}) => {
  return (
    <StyledFormActions isAtBottom={isAtBottom}>
      <Button
        type="default"
        icon={<LeftOutlined />}
        onClick={onCancel}
      >
        Hủy
      </Button>
      <Button type="dashed" onClick={onSaveAndHide}>
        Lưu & Ẩn
      </Button>
      <Button type="primary" onClick={onSaveAndShow}>
        Lưu & Hiển thị
      </Button>
    </StyledFormActions>
  );
};

export default FormActions;